import { FC, useContext, useMemo } from "react";
import { useRecoilValue } from "recoil";

import { StationRouteContext, useCrudEditContext } from "@ryde/redux";
import {
  apiDataFetchingAtom,
  editFormDataAF,
  EditFormMode,
  getStationRouteRoutesInfo,
  isStationRouteWaypointEditingAllowed,
  IStationRouteDto,
  MapRouteBlockTypeEnum,
} from "@ryde/shared";

import { RouteBlock } from "../../../map";
import { StationRouteWaypointMapControlsHost } from "../parts";
import {
  StationRouteMapStyled,
  StationRouteMapWrapperStyled,
} from "./station-route.styled";

interface IStationRouteMap {
  mode?: EditFormMode | undefined;
}

export const StationRouteMap: FC<IStationRouteMap> = ({ mode }) => {
  const { entity } = useCrudEditContext<IStationRouteDto>();
  const { rideOpenerId } = useContext(StationRouteContext);
  const stationRouteDto = useRecoilValue<Partial<IStationRouteDto> | undefined>(
    editFormDataAF([entity, mode || EditFormMode.CrudRoute]),
  );

  const waypointEditingAllowed = isStationRouteWaypointEditingAllowed(
    rideOpenerId,
    stationRouteDto?.customized,
  );

  const routes = useMemo(
    () => getStationRouteRoutesInfo(stationRouteDto),
    [stationRouteDto],
  );

  const dataLoading = useRecoilValue(apiDataFetchingAtom);

  const mapHiddenStateCondition = useMemo(() => {
    return Boolean(dataLoading);
  }, [dataLoading]);

  return (
    <StationRouteMapWrapperStyled className="StationRouteDrawer-Map">
      <StationRouteMapStyled>
        <RouteBlock
          hiddenMapState={mapHiddenStateCondition}
          routes={routes}
          routeBlockType={MapRouteBlockTypeEnum.StationRoutes}
          mapExtraLayers={
            waypointEditingAllowed ? (
              <StationRouteWaypointMapControlsHost />
            ) : undefined
          }
        />
      </StationRouteMapStyled>
    </StationRouteMapWrapperStyled>
  );
};
